import axios from "../axiosInstance"
import { converterArquivoStreamParaBlob } from "../shared/utils/ArquivoUtil"
import {
	amostras,
	tipos,
	status,
	listarArquivos,
	baixarArquivos,
	planilhaAmostras,
} from "../shared/utils/Endpoints"
import { formatarDataRequisicao } from "../shared/utils/Formatacao"
import moment from "moment"
import qs from "qs"

class AmostrasService {
	async listarAmostras(operacoesListagem, uuid) {
		const filtros = operacoesListagem.filtros;
		const paginacao = operacoesListagem.paginacao;
		const ordenacao = operacoesListagem.ordenacao;

		return await axios.get(amostras, {
			params: {
				Termo: filtros && filtros.busca,
				TiposAmostra: filtros && filtros.tipos && filtros.tipos.map(tipo => tipo.codigo),
				ListaStatusAmostra: filtros && filtros.status,
				FiltrarPorDescricaoTipoAmostra: operacoesListagem.filtrarPorDescricaoTipoAmostra,
				IdTipoConservacaoLote: operacoesListagem.idTipoConservacaoLote && Number(operacoesListagem.idTipoConservacaoLote),
				IdLote: operacoesListagem.idLote && Number(operacoesListagem.idLote),
				SomenteNaoInclusasEmLote: operacoesListagem.somenteNaoInclusasEmLote,
				DataInicioPeriodo: filtros && formatarDataRequisicao(filtros.dataInicio),
				DataFinalPeriodo: filtros && formatarDataRequisicao(filtros.dataFinal),
				Pagina: paginacao && paginacao.pagina,
				ItensPorPagina: paginacao && paginacao.itensPagina,
				ColunaOrdenacao: ordenacao && ordenacao.coluna,
				OrdenacaoDecrescente: ordenacao && ordenacao.decrescente,
				idEmpresa: !operacoesListagem.idLote ? operacoesListagem.idEmpresa : null,
				UUID: uuid
			},
			paramsSerializer: (params) => {
				return qs.stringify(params)
			}
		});
	}

	async baixarPlanilha(operacoesListagem) {
		const filtros = operacoesListagem.filtros;
		const ordenacao = operacoesListagem.ordenacao;

		return await axios.get(planilhaAmostras, {
			params: {
				Termo: filtros && filtros.busca,
				TiposAmostra: filtros && filtros.tipos && filtros.tipos.map(tipo => tipo.codigo),
				ListaStatusAmostra: filtros && filtros.status,
				DataInicioPeriodo: filtros && formatarDataRequisicao(filtros.dataInicio),
				DataFinalPeriodo: filtros && formatarDataRequisicao(filtros.dataFinal),
				ColunaOrdenacao: ordenacao && ordenacao.coluna,
				OrdenacaoDecrescente: ordenacao && ordenacao.decrescente,
			},
			paramsSerializer: (params) => {
				return qs.stringify(params)
			},
			responseType: "arraybuffer"
		}).then((res) => {
            if (res?.data) {
                return converterArquivoStreamParaBlob(res.data);
            }
        });;
	}

	async listarTipos() {
		return await axios.get(tipos, { cache: true })
	}

	async listarStatus() {
		return await axios.get(status, { cache: true })
	}

	async cadastrarAmostra(dados, retornarErro) {
		return await axios.post(amostras, {
			CodigoAmostra: dados.numeroEtiqueta,
			NomePaciente: dados.nomePaciente,
			Cpf: dados.cpf,
			NumeroPedido: dados.numeroPedido,
			DataPedido: dados.dataPedido ? formatarDataRequisicao(moment(dados.dataPedido, "DD/MM/YYYY")) : null,
			DetalhesAmostra: {
				ConvenioDiagSystem: dados.convenio ? dados.convenio : 0,
				Carteira: dados?.numeroCarteira,
				UfConselhoSolicitante: dados?.dadosSolicitante[0]?.ufConselho,
				ConselhoSolicitante: dados?.dadosSolicitante[0]?.siglaConselho,
				NumeroConselhoSolicitante: dados?.dadosSolicitante[0]?.numeroConselho
			},
			Sexo: dados.sexo,
			DataNascimento: dados.dataNascimento ? formatarDataRequisicao(moment(dados.dataNascimento, "DD/MM/YYYY")) : null,
			ListExames: dados.listExames,
			IdTipoAmostra: Number(dados.tipoAmostra),
			CodigoTipoConservacao: dados.tipoConservacao,
			Empresa: dados.empresa,
			EspecificacaoAmostra: dados.especificacao,
			GuidsArquivos: dados.guidsArquivos,
			Exames: dados.exames
		}, {
			returnResponseOnError: retornarErro,
		});
	}

	async listarArquivos(idAmostra) {
		return await axios.get(listarArquivos.replace(/{id}/, idAmostra));
	}

	async baixarArquivos(idAmostra, idArquivo) {
		return await axios.get(
			baixarArquivos
				.replace(/{idAmostra}/, idAmostra)
				.replace(/{idArquivoAmostra}/, idArquivo),
			{
				responseType: "blob"
			}
		);
	}
}

export default new AmostrasService()